import {
  expenseVoucherDownload,
  getExpenseVoucherReport,
  getPaymentTransactionDetailsApi,
  getPaymentTransactionListApi,
  getServiceTransactionDetailsApi,
  getVoucherReport,
  serviceVoucherDownload,
} from "_services/accountingServices/accountingServices";

import { CustomPagination } from "components";
import Tab from "components/common/Tab";
import { constant, genExpensedata } from 'constants/constant';
import { useContext, useEffect, useRef, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import StorageService from "utils/StorageServices";
import { GenExpense } from "./GenExpenseFormat";
import { utils } from "helper";
import { UserContext } from "context";
import {
  ConfirmModalFor,
  MakePaymentForExpense,
  PaymentConfirmModal,
  PaymentProcessingOffcanvas,
  PaymentStatusCard,
  PaymentSuccessOffcanvas,
  PaymentVoucher
} from "modals";
import './transactionExpDetails.css';
import { getServiceVoucherList } from "_services/workShopServices/workShopServices";
import { FaRegTrashCan } from "react-icons/fa6";
import { deleteTransactionApi } from "_services";
import toast from "react-hot-toast";
import { Images } from "constants";
import images from "constants/images";
import { API, AppConfig } from "lib";
import printHtmlContent from "helper/utils";
let isToken = localStorage.getItem("token");
const toFixed2 = (val) => (Number(val) || 0).toFixed(2);

const TAB_CONFIG = {
  1: {
    label: "Expenses",
    listApi: (payload) => getPaymentTransactionListApi(payload),
    detailApi: ({ id }) => getPaymentTransactionDetailsApi({ expense_id: id }),
    detailKey: "expense",
  },
  2: {
    label: "Servicing",
    listApi: (payload) => getServiceVoucherList(payload),
    detailApi: ({ id }) => getServiceTransactionDetailsApi({ service_id: id }),
    detailKey: "expense",
  },
};

const TransactionExpDetails = () => {
  const { id } = useParams();
  const [query] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { masterData } = useContext(UserContext);

  const qOffset = +query.get('offset') || 1;
  const qTotalRecord = +query.get('total_record') || 0;
  const [searchParams] = useSearchParams();

  const sequenceNo = searchParams.get("sequence_no");
  const status = searchParams.get('status');
  const invoice = searchParams.get('invoice');

  const tab = Number(searchParams.get('tab') ?? '1');

  const itemsPerPage = 10;

  const [activeTab, setActiveTab] = useState(1);
  const [list, setList] = useState([]);
  const [totalRecord, setTotalRecord] = useState(qTotalRecord);
  const [currentPage, setCurrentPage] = useState(qOffset);
  const [details, setDetails] = useState(null);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [isOpenPayment, setIsOpenPayment] = useState(false);
  const [isOpenPayNow, setIsOpenPayNow] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [paymentData, setPaymentData] = useState({ voucher_id: "", data: {} });
  const [isMakeStatusOpen, setIsMakeStatusOpen] = useState(false);
  const [canvasKey, setCanvasKey] = useState(0);
  const [eaesbuzzId, setEaesbuzzId] = useState({ eb_account_id: "", total_amount: 0 });
  const [confirmModalShow, setConfirmModalShow] = useState(false);
  const [transationDetails, setTransationDetails] = useState();
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [pDfReport, setPDfReport] = useState("")
  const [downloadingId, setDownloadingId] = useState(null);
  const isTabChangeRef = useRef(false);
  const [isGetDetailsLoading, setIsGetDetailsLoading] = useState(false)
  const [paymentVoucherOpen, setPaymentVoucherOpen] = useState(false);
  const [printLoadingId, setPrintLoadingId] = useState(null);
  // Existing states ke saath yeh add karo
  const [headerInfo, setHeaderInfo] = useState({
    sequenceNo: searchParams.get("sequence_no") || '',
    status: searchParams.get('status') || '',
    invoice: searchParams.get('invoice') || '',
    id: searchParams.get('id') || '',
  });

  const isPaymentAllowed = customerDetails &&
    (customerDetails.status !== "Completed" || customerDetails.payment_status !== "Completed");

  const tabProps = {
    tabList: constant.transactionExpensesTabs,
    callBackTab: setActiveTab,
    activeTab,
    isActiveButton: isPaymentAllowed,
    tabButtonName: 'Record Payment',
    rightButton: () => setIsOpenPayment(true),
  };

  // ── Fetch List ───────────────────────────────────────────────
  const fetchList = async (offset = 1, tabId = tab) => {
    const config = TAB_CONFIG[tabId];
    if (!config) return;

    try {
      const payload = {
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        limit: itemsPerPage,
        offset,
      };

      const res = await config.listApi(payload);

      if (res?.responseCode === 200) {
        const items = res?.data?.list || [];
        const isTabChange = isTabChangeRef.current;

        const selectedItem = isTabChange
          ? items[0]
          : items.find((el) => el?._id === id) || null;

        setList(items);
        setTotalRecord(res?.data?.total_record);
        if (selectedItem) setDetails(selectedItem);

        const params = new URLSearchParams(location.search);
        params.set('offset', offset);
        params.set('total_record', res?.data?.total_record);

        if (isTabChange && selectedItem) {
          params.set('sequence_no', selectedItem?.sequence_no || '');
          params.set('status', selectedItem?.status || selectedItem?.payment_status || '');
          params.set('invoice', selectedItem?.invoice_number || '');
          navigate(`/accounting/ptransactions/${selectedItem._id}?${params.toString()}`, { replace: true });
        } else {
          // ✅ Pagination ya payment-after-refresh pe — current id ka status URL me sync karo
          if (selectedItem) {
            params.set('status', selectedItem?.status || selectedItem?.payment_status || '');
          }
          navigate(`/accounting/ptransactions/${id}?${params.toString()}`, { replace: true });
        }

        isTabChangeRef.current = false;
      }
    } catch (err) {
      console.error(err);
    }
  };

  // ── Fetch Details ────────────────────────────────────────────
  // ✅ FIX: details fetch hone ke baad URL status param bhi update karo
  // const fetchDetails = async (tabId = tab) => {
  //   const config = TAB_CONFIG[tabId];
  //   if (!config || !id) return;

  //   try {
  //     const res = await config.detailApi({ id });
  //     if (res?.responseCode === 200) {
  //       const expenseData = res?.data?.expense || res?.data;
  //       setCustomerDetails(expenseData);
  //       setIsGetDetailsLoading(false)

  //       if (expenseData?.due_amount == 0) {
  //         fetchList(qOffset, tab);
  //       }

  //       // ✅ Naya status URL me update karo — header instantly reflect karega
  //       const newStatus = expenseData?.status || expenseData?.payment_status || '';
  //       const params = new URLSearchParams(location.search);
  //       params.set('status', newStatus);
  //       navigate(`/accounting/ptransactions/${id}?${params.toString()}`, { replace: true });
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };
  const fetchDetails = async (tabId = tab) => {
    const config = TAB_CONFIG[tabId];
    if (!config || !id) return;

    try {
      const res = await config.detailApi({ id });
      if (res?.responseCode === 200) {
        const expenseData = res?.data?.expense || res?.data;
        setCustomerDetails(expenseData);

        const newStatus = expenseData?.status || expenseData?.payment_status || '';
        setHeaderInfo(prev => ({ ...prev, status: newStatus }));

        // ✅ Left panel list in-place update
        setList(prev =>
          prev.map(item =>
            item._id === id
              ? { ...item, status: newStatus, payment_status: newStatus }
              : item
          )
        );

        if (expenseData?.due_amount == 0) {
          fetchList(qOffset, tab);
        }

        const params = new URLSearchParams(location.search);
        params.set('status', newStatus);
        navigate(`/accounting/ptransactions/${id}?${params.toString()}`, { replace: true });
      }
    } catch (err) {
      console.error(err);
    } finally {
      // 🔓 unlock — API complete hone ke baad hi
    }
  };

  const fetchExpenseVoucherHandle = async (id, is_web = false) => {

    if (!id) return;
    const payload = {
      expense_id: id,
      is_web: is_web
    }

    try {

      if (!is_web) {
        const res = tab == 1 ? await expenseVoucherDownload(payload) : await serviceVoucherDownload(payload);
        setPDfReport(res);
        setIsGetDetailsLoading(false);
      } else {

        setDownloadingId(id);

        const response = await fetch(`${AppConfig.api_baseurl}${tab == 1 ? API.EXPENSE_VOUCHER_DOWNLOAD : API.SERVICE_VOUCHER_DOWNLOAD}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Token': `${isToken}`,
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) throw new Error('Network response was not ok');

        const contentDisposition = response.headers.get('Content-Disposition');
        const filenameMatch = contentDisposition?.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        const filename = filenameMatch?.[1]
          ? decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''))
          : tab == 1 ? `expense-${id}.pdf` : `service-${id}.pdf`;

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        setDownloadingId(false);

      }

    } catch (err) {
      console.error(err);
      setDownloadingId(false);
    }
  };

  // ── Left Dropdown Tab Change ─────────────────────────────────
  // const handleTabChange = (tabId) => {
  //   if (tabId === tab) return;
  //   isTabChangeRef.current = true;
  //   setList([]);
  //   setDetails(null);
  //   setCustomerDetails(null);
  //   setCurrentPage(1);
  //   setActiveTab(1);

  //   const params = new URLSearchParams(location.search);
  //   params.set('tab', tabId);
  //   params.delete('offset');
  //   // ✅ Tab change hote hi purana status/sequence_no/invoice clear karo — flicker band
  //   params.delete('status');
  //   params.delete('sequence_no');
  //   params.delete('invoice');
  //   navigate(`${location.pathname}?${params.toString()}`);
  // };
  const handleTabChange = (tabId) => {
    if (tabId === tab) return;
    isTabChangeRef.current = true;
    setList([]);
    setDetails(null);
    setCustomerDetails(null);
    setCurrentPage(1);
    setActiveTab(1);
    setHeaderInfo({ sequenceNo: '', status: '', invoice: '' }); // ✅ clear

    const params = new URLSearchParams(location.search);
    params.set('tab', tabId);
    params.delete('offset');
    params.delete('status');
    params.delete('sequence_no');
    params.delete('invoice');
    navigate(`${location.pathname}?${params.toString()}`);
  };
  const handlePrintDownload = async (voucherId) => {
    try {
      setPrintLoadingId(id);

      const res = await getExpenseVoucherReport({
        company_id: StorageService?.getCompanyId(),
        voucher_id: tab == 1 ? id : voucherId,
      });

      printHtmlContent({
        html: res,
        title: `Bilty-${id}`,
        onAfter: () => setPrintLoadingId(false),
      });

    } catch (err) {
      console.error('Print error:', err);
      setPrintLoadingId(false);
    }
  };

  // ── Effects ──────────────────────────────────────────────────
  useEffect(() => {
    fetchList(qOffset, tab);
  }, [tab]);

  useEffect(() => {
    // ✅ Tab change pe fetchDetails mat chalaо — fetchList naya id set karega
    // fetchDetails sirf tab-same hone par id change pe chalega
    if (id && !isTabChangeRef.current) {
      fetchDetails(tab);
      fetchExpenseVoucherHandle(id)
    }
  }, [id, tab]);

  // ── Pagination ───────────────────────────────────────────────
  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchList(page, tab);
  };

  // ── List Item Click ──────────────────────────────────────────
  // const handleItemClick = (item) => {
  //   // Prevent multiple clicks while loading
  //   if (isGetDetailsLoading || item._id === id) return;

  //   setIsGetDetailsLoading(true);
  //   setDetails(item);

  //   const params = new URLSearchParams(location.search);
  //   params.set('sequence_no', item?.sequence_no || '');
  //   params.set('status', item?.status || item?.payment_status || '');
  //   params.set('invoice', item?.invoice_number || '');
  //   navigate(`/accounting/ptransactions/${item._id}?${params.toString()}`);
  // };
  // const handleItemClick = (item) => {
  //   if (isGetDetailsLoading || item._id === id) return;

  //   // ✅ Sab state ek saath batch update karo
  //   setIsGetDetailsLoading(true);
  //   setDetails(item);
  //   setPDfReport(""); // ✅ Purana PDF clear karo — blank > stale content

  //   const params = new URLSearchParams(location.search);
  //   params.set('sequence_no', item?.sequence_no || '');
  //   // ✅ Status immediately set karo list item se hi — header flicker band
  //   params.set('status', item?.status || item?.payment_status || '');
  //   params.set('invoice', item?.invoice_number || '');

  //   navigate(`/accounting/ptransactions/${item._id}?${params.toString()}`);
  // };

  const handleItemClick = (item) => {
    if (isGetDetailsLoading || item._id === id) return; // ✅ already block kar raha hai

    setIsGetDetailsLoading(true); // 🔒 lock
    setDetails(item);
    setCustomerDetails(null); // ✅ purani detail clear — stale data band
    setPDfReport("");

    const newSequenceNo = item?.sequence_no || '';
    const newStatus = item?.status || item?.payment_status || '';
    const newInvoice = item?.invoice_number || '';

    setHeaderInfo({ sequenceNo: newSequenceNo, status: newStatus, invoice: newInvoice });

    const params = new URLSearchParams(location.search);
    params.set('sequence_no', newSequenceNo);
    params.set('status', newStatus);
    params.set('invoice', newInvoice);
    navigate(`/accounting/ptransactions/${item._id}?${params.toString()}`);
  };
  // ── Easebuzz Callback ────────────────────────────────────────
  const callbackEaesbuzz = (ebId, amount, venderDetails, payload) => {
    setEaesbuzzId((prev) => ({
      ...prev,
      eb_account_id: ebId,
      total_amount: amount,
      vendor_bank_account: venderDetails?.vendor_bank_account,
      payload,
    }));
  };

  // ── Handlers ─────────────────────────────────────────────────
  const onShareReceipt = () => { };
  const viewReceiptHandle = (data) => setIsSuccessOpen(data);

  // ✅ FIX: payment done hone ke baad list + details dono refresh karo
  // fetchDetails URL status update karega, fetchList left panel update karega
  const doneHandle = () => {
    fetchDetails(tab);
    fetchList(currentPage, tab);
    setIsOpenPayment(false);
    setIsOpenPayNow(false);
    setIsMakeStatusOpen(false);
  };

  // ✅ FIX: payment result pe bhi list refresh karo
  const paymentResult = (data, voucher_id) => {
    fetchDetails(tab);
    fetchList(currentPage, tab);
    setIsOpenPayment(false);
    setIsProcessing(false);
    setIsOpenPayNow(false);
    setIsMakeStatusOpen(true);
    setPaymentData({ voucher_id, data });
    setCanvasKey((prev) => prev + 1);
  };

  const handleDownloadReceipt = async () => {
    try {
      const response = await fetch(`/api/receipt/${paymentData?.transactionId}`);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `receipt_${paymentData?.transactionId}.pdf`;
      link.click();
      URL.revokeObjectURL(url);
    } catch {
      alert('Failed to download receipt');
    }
  };

  const handleDelete = async () => {
    const payload = {
      company_id: StorageService?.getCompanyId(),
      transaction_id: transationDetails?.transaction_id,
    };
    try {
      setDeleteLoading(true);
      const res = await deleteTransactionApi(payload);
      if (res?.responseCode == 200) {
        toast.success(res?.responseMessage);
        setConfirmModalShow(false);
        setTransationDetails("");
        setDeleteLoading(false);
        // ✅ Delete ke baad bhi dono refresh karo
        setPaymentVoucherOpen(false)
        fetchDetails(tab);
        fetchList(currentPage, tab);
      } else {
        setDeleteLoading(false);
      }
    } catch (error) {
      setDeleteLoading(false);
    }
  };

  const deleteHandler = (item) => {
    setConfirmModalShow(item);

    setTransationDetails(item);
  };

  // ── Status Style ─────────────────────────────────────────────
  const getStatusStyle = (s) => {
    const map = {
      Completed: { label: "Completed", color: "#22C55E" },
      Cancelled: { label: "Cancelled", color: "#EF4444" },
      Pending: { label: "Pending", color: "#F97316" },
    };
    return map[s] || { label: s || "-", color: "#6B7280" };
  };

  const extractBody = (html) => {
    const match = html.match(/<body[^>]*>((.|[\n\r])*)<\/body>/im);
    return match ? match[1] : html;
  };

  const transactions = customerDetails?.transactions || [];

  // ── Modal Props ──────────────────────────────────────────────
  const makePaymentProps = {
    isOpen: isOpenPayment,
    closeModal: () => setIsOpenPayment(false),
    headerPart: false,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _lgModal",
    modalTitle: "Add Payment",
    submitTitle: "Add Payment",
    details,
    customerDetails,
    callbackEaesbuzz,
    setIsOpenPayNow,
    callBackFreight: () => {
      fetchDetails(tab);
      fetchList(currentPage, tab);
    },
    tab
  };

  const paymentVoucherProps = {
    paymentVoucherOpen: paymentVoucherOpen,
    closeModal: () => setPaymentVoucherOpen(false),
    voucherId: paymentVoucherOpen?._id,
    oprnDeleteModal: setConfirmModalShow,
    onPrintHandle: handlePrintDownload,
    printLoadingId,
    expenseId: id
  }

  const payNowProps = {
    isOpen: isOpenPayNow,
    closeModal: () => setIsOpenPayNow(false),
    setIsProcessing,
    setIsOpenPayNow,
    easebuzzDetails: eaesbuzzId,
  };

  let confirmModalProps = {
    show: confirmModalShow,
    closeModal: () => {
      setConfirmModalShow(false);
      setTransationDetails("");
    },
    title: "Confirm",
    submitTitle: "Delete",
    onSubmit: handleDelete,
    confirmModal: "confirmModal",
    icon: Images.DELETEICON.default,
    isLoadding: deleteLoading,
    disabled: deleteLoading,
  };


  const handlePrintVoucher = () => {
    if (!pDfReport) return;

    const printFrame = document.getElementById("print-frame") || (() => {
      const iframe = document.createElement("iframe");
      iframe.id = "print-frame";
      iframe.style.cssText = "position:fixed;top:-9999px;left:-9999px;width:0;height:0;border:none;";
      document.body.appendChild(iframe);
      return iframe;
    })();

    const doc = printFrame.contentDocument || printFrame.contentWindow.document;
    doc.open();
    doc.write(pDfReport);
    doc.close();

    printFrame.contentWindow.focus();
    printFrame.contentWindow.print();
  };

  // ── Render ───────────────────────────────────────────────────
  return (
    <div className='trs-listDetail'>

      {/* ── Left: List Panel ── */}
      <div className='trs-listBx_ns'>
        <div className='trs-dropDown-head'>
          <div className="dropdown">
            <button className="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              {TAB_CONFIG[tab]?.label || "General Expenses"}
            </button>
            <ul className="dropdown-menu">
              {Object.entries(TAB_CONFIG).map(([tabId, cfg]) => (
                <li key={tabId}>
                  <a
                    className={`dropdown-item px-2 ${tab == tabId ? 'active' : ''}`}
                    onClick={() => handleTabChange(Number(tabId))}
                  >
                    {cfg.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className='trs-listBx_ns_content'>
          <div className='trs-listBx_ns_content_list'>
            {list.length > 0
              ? list.map((item) => (
                <div
                  key={item._id}
                  className={`trs-line${item._id === id ? ' active' : ''}`}
                  onClick={() => {
                    if (!isGetDetailsLoading) {
                      handleItemClick(item)
                    }
                    // console.log("isGetDetailsLoading",isGetDetailsLoading)
                    // !isGetDetailsLoading && handleItemClick(item)
                  }}
                >
                  <div className='trs-listBx-heading'>
                    <p>{item?.vendor_detail?.name || item?.firm?.firm || 'Name not available'}</p>
                    <span>
                      {item?.sequence_no || item?.invoice_number} |{' '}
                      {(item?.date || item?.service_date)
                        ? new Date(item.date || item?.service_date).toLocaleDateString('en-IN')
                        : '-'}
                    </span>
                    {/* ✅ Left panel me status: list refresh ke baad naya status dikhega */}
                    <div className='trs-status' style={{ background: getStatusStyle(item?.status || item?.payment_status).color }}>
                      {getStatusStyle(item?.status || item?.payment_status).label || 'Unpaid'}
                    </div>
                  </div>
                </div>
              ))
              : <p className="trs-ph-empty">No records found.</p>
            }
          </div>

          {list.length > 0 && (
            <div className='paginationFt_avt'>
              <CustomPagination
                totalItems={totalRecord}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>

      {/* ── Right: Detail Panel ── */}
      <div className='trs-detailBx'>
        <div className='trs-detailBx_head'>
          {/* ── Right: Detail Panel header ── */}
          <div className='trs-left-head'>
            {/* ✅ URL params ki jagah headerInfo use karo — no flicker */}
            {(headerInfo.sequenceNo || headerInfo.invoice) && (
              <p>{headerInfo.sequenceNo || headerInfo.invoice}</p>
            )}
            <div className='trs-status' style={{ background: getStatusStyle(headerInfo.status).color }}>
              {getStatusStyle(headerInfo.status).label || '-'}
            </div>
          </div>
          <div className='trs-right-head'>
            <button className='trs-dwn-btn anime-btn' onClick={() => fetchExpenseVoucherHandle(id, true)}>{downloadingId ? "Downloading.." : "Download PDF"}</button>
            <button className='trs-dwn-btn anime-btn' onClick={() => handlePrintVoucher()}>Print Voucher</button>
            <button className='trs-cancel-btn' onClick={() => navigate("/accounting/ptransactions")}>
              <RxCross2 />
            </button>
          </div>
        </div>

        <div className='trs-inp-tabBxs'>
          <div className="addPr_flBx __uiTx_new">
            <Tab {...tabProps} />
            <div className='trs-inp-tabContent'>

              {/* {activeTab === 1 && <GenExpense data={genExpensedata} />} */}
              {activeTab === 1 && (
                <div style={{ position: 'relative', minHeight: '200px' }}>
                  {isGetDetailsLoading && (
                    <div style={{
                      position: 'absolute', inset: 0,
                      background: 'rgba(255,255,255,0.7)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      zIndex: 1
                    }}>
                      Loading...
                    </div>
                  )}
                  <div dangerouslySetInnerHTML={{ __html: pDfReport }} />
                </div>
              )}

              {activeTab === 2 && (
                <div className="trs-payment-history-card">
                  <div className="trs-ph-header">
                    <h3>Payment History</h3>
                    <div className="trs-ph-row">
                      <span className="trs-ph-label">Invoice Amount</span>
                      <span className="trs-ph-amount">₹ {toFixed2(customerDetails?.total_amount)}</span>
                    </div>
                  </div>

                  <div className="trs-ph-payment-box">
                    {transactions.length > 0
                      ? transactions.map((t, i) => (
                        <div key={t?._id || i}>
                          <div className="trs-ph-payment-row">
                            <div onClick={() => {
                              setPaymentVoucherOpen(t)
                              setTransationDetails(t);
                            }
                            } style={{ cursor: "pointer" }}>
                              <div className="trs-ph-payment-title">
                                Payment
                                {t?.approval_status != null && t?.approval_status !== 0 && (
                                  <span className="trs-ph-badge">
                                    {masterData?.payment_approval_status?.[t?.approval_status]}
                                  </span>
                                )}
                              </div>
                              <div className="trs-ph-payment-meta">
                                {(t?.date || t?.service_date) ? utils.formatDateMonth(t.date || t?.service_date) : '-'} |{' '}
                                {t?.voucher_no || '-'} |{' '}
                                {t?.payment_mode?.account?.name || '-'}
                              </div>
                            </div>

                            <div className="trs-ph-payment-amount" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
                              <div>₹ {toFixed2(t?.total_amount)}</div>
                              <FaRegTrashCan color='red' onClick={() => deleteHandler(t)} style={{ cursor: "pointer" }} />
                            </div>
                          </div>
                          {i < transactions.length - 1 && <div className="trs-ph-divider" />}
                        </div>
                      ))
                      : <p className="trs-ph-empty">No payment history found.</p>
                    }
                  </div>

                  <div className="trs-ph-footer">
                    <div className="trs-ph-row">
                      <span className="trs-ph-label">Invoice Amount Received</span>
                      <span className="trs-ph-amount">₹ {toFixed2(customerDetails?.paid_amount)}</span>
                    </div>
                    <div className="trs-ph-row">
                      <span className="trs-ph-label trs-ph-danger">Balance Due</span>
                      <span className="trs-ph-amount trs-ph-danger">₹ {toFixed2(customerDetails?.due_amount)}</span>
                    </div>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      </div>

      {/* ── Modals ── */}
      {isOpenPayment && <MakePaymentForExpense {...makePaymentProps} />}
      {paymentVoucherOpen && <PaymentVoucher {...paymentVoucherProps} />}
      {isOpenPayNow && <PaymentConfirmModal {...payNowProps} />}

      {isProcessing?.selectedMethod && (
        <PaymentProcessingOffcanvas
          isOpen={isProcessing}
          message="Please wait while we process your transaction..."
          paymentResult={paymentResult}
          eaesbuzzId={eaesbuzzId}
          onClose={() => { setIsProcessing(false); setIsOpenPayNow(false); setIsOpenPayment(false); }}
        />
      )}

      {isMakeStatusOpen && (
        <PaymentStatusCard
          isOpen={isMakeStatusOpen}
          onClose={() => setIsMakeStatusOpen(false)}
          paymentData={paymentData}
          details={{ _id: paymentData?.data?.voucher_id }}
          onShareReceipt={onShareReceipt}
          viewReceiptHandle={viewReceiptHandle}
          doneHandle={doneHandle}
        />
      )}

      {isSuccessOpen && (
        <PaymentSuccessOffcanvas
          isOpen={isSuccessOpen}
          onClose={() => setIsSuccessOpen(false)}
          paymentData={paymentData}
          onDownloadReceipt={handleDownloadReceipt}
          onContactUs={() => alert('Contact support')}
        />
      )}

      <div className={isSuccessOpen ? "offBack_drop" : ""} />

      {confirmModalShow && (
        <ConfirmModalFor {...confirmModalProps}>
          <>
            <p className="_confirmPrx">
              Are you sure you want to Cancel "Transaction"?
            </p>
          </>
        </ConfirmModalFor>
      )}
    </div>
  );
};

export default TransactionExpDetails;